import { CIEN_CUADRAS_BLUE } from '../../../firebase/firebaseConfig';

declare var L: any;
declare var turf: any;

export const MAP_DEFAULT_CENTER: [number, number] = [4.5709, -74.2973];
export const MAP_DEFAULT_ZOOM = 6;

export const createPropertyIcon = (type: string | undefined) => {
  let color = '#3b82f6';
  const normalizedType = (type || '').toLowerCase().replace(/\s+/g, '');
  if (normalizedType.includes('casa')) color = '#22c55e';
  else if (normalizedType.includes('oficina')) color = '#8b5cf6';
  else if (normalizedType.includes('local')) color = '#ef4444';
  else if (normalizedType.includes('bodega')) color = '#a16207';

  return L.divIcon({
    html: `<div style="background-color: ${color}; width: 14px; height: 14px; border-radius: 50%; border: 2px solid white; box-shadow: 0 1px 3px rgba(0,0,0,0.3);"></div>`,
    className: '',
    iconSize: [18, 18],
    iconAnchor: [9, 9],
  });
};

export const createGeoJsonLayer = (spatialFilter: any) => {
  if (!spatialFilter) return null;
  const geom = spatialFilter.geometry;
  const isCircle = (spatialFilter.mode === 'radius' || spatialFilter.mode === 'circle' || geom?.properties?.isCircle === true) && spatialFilter.center && spatialFilter.radius;

  if (isCircle && spatialFilter.center) {
    return L.circle([spatialFilter.center.lat, spatialFilter.center.lon || spatialFilter.center.lng], {
      radius: spatialFilter.radius,
      color: CIEN_CUADRAS_BLUE,
      fillOpacity: 0.15,
      weight: 2,
      interactive: true,
    });
  }

  if (geom) {
    const collection = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: geom,
          properties: { type: 'buffer' },
        },
      ],
    };

    if (spatialFilter.siteGeometry) {
      collection.features.push({
        type: 'Feature',
        geometry: spatialFilter.siteGeometry,
        properties: { type: 'site' },
      });
    }

    return L.geoJSON(collection, {
      style: (feature: any) => ({
        color: feature.properties?.type === 'site' ? '#00234F' : CIEN_CUADRAS_BLUE,
        fillOpacity: feature.properties?.type === 'site' ? 0.35 : 0.1,
        weight: feature.properties?.type === 'site' ? 2 : 1.5,
      }),
      interactive: true,
    });
  }

  return null;
};
